(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('[data-dut-subtype-intro]').forEach((intro, index) => {
      if (intro.closest('.dut-subtype-intro')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'dut-subtype-intro';
      intro.before(wrapper);
      wrapper.append(intro);
      intro.classList.add('dut-subtype-intro__content');

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dut-subtype-intro__toggle';
      button.textContent = 'Read more';
      button.setAttribute('aria-expanded', 'false');
      intro.id ||= `SubtypeIntro-${intro.closest('.shopify-section')?.id || 'main'}-${index + 1}`;
      button.setAttribute('aria-controls', intro.id);
      wrapper.append(button);

      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? 'Read less' : 'Read more';
        wrapper.classList.toggle('is-expanded', open);
      });
    });
  };
  enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
